import { createSlice } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { MainFilters } from '../../types/state';

const initialState: MainFilters = {
  data: [],
  fetchingStatusFilters: false,
  error: null
};

export const filtersMainVPO = createSlice({
  name: NameSpace.FiltersMain,
  initialState,
  reducers: {
    fetchFiltersRequestVPO: (state) => {
      state.fetchingStatusFilters = true;
      state.error = null;
    },
    fetchFiltersSuccessVPO: (state, action) => {
      state.fetchingStatusFilters = false;
      state.data = action.payload;
    },
    fetchFiltersFailureVPO: (state, action) => {
      state.fetchingStatusFilters = false;
      state.error = action.payload;
    },
  },
});

export const { fetchFiltersRequestVPO, fetchFiltersSuccessVPO, fetchFiltersFailureVPO } = filtersMainVPO.actions;
